(function () {
  // Scroll-to-target: handles any [data-scroll-target] click via event delegation.
  // Replaces per-section inline scroll handlers in floating-cta, section-cta,
  // custom-hero-fv, and header.
  document.addEventListener('click', function (e) {
    var el = e.target.closest('[data-scroll-target]');
    if (!el) return;
    var target = document.querySelector(el.dataset.scrollTarget);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Image magnifier: auto-initializes all [data-magnifier] gallery containers.
  // Configure via data attributes:
  //   data-magnifier-img   — CSS selector for the main <img>
  //   data-magnifier-lens  — CSS class name for the lens div (default: "mm-lens")
  //   data-magnifier-zoom  — zoom factor (default: 2.5)
  function initMagnifier(galleryEl) {
    var mainImg = document.querySelector(galleryEl.dataset.magnifierImg);
    if (!mainImg || !window.matchMedia('(hover: hover)').matches) return;
    var lensClass = galleryEl.dataset.magnifierLens || 'mm-lens';
    var zoom = parseFloat(galleryEl.dataset.magnifierZoom) || 2.5;
    var bw = 3;
    var lens = document.createElement('div');
    lens.className = lensClass;
    galleryEl.appendChild(lens);
    var rafPending = false;
    var lastEvent;
    function applyMove(e) {
      var imgRect = mainImg.getBoundingClientRect();
      var w = lens.offsetWidth / 2;
      var h = lens.offsetHeight / 2;
      var x = Math.max(Math.min(e.clientX - imgRect.left, imgRect.width - w / zoom), w / zoom);
      var y = Math.max(Math.min(e.clientY - imgRect.top, imgRect.height - h / zoom), h / zoom);
      lens.style.left = (x - w) + 'px';
      lens.style.top = (y - h) + 'px';
      lens.style.backgroundImage = 'url(' + JSON.stringify(mainImg.currentSrc || mainImg.src) + ')';
      lens.style.backgroundSize = (imgRect.width * zoom) + 'px ' + (imgRect.height * zoom) + 'px';
      lens.style.backgroundPosition = '-' + ((x * zoom) - w + bw) + 'px -' + ((y * zoom) - h + bw) + 'px';
    }
    galleryEl.addEventListener('mouseenter', function () { galleryEl.classList.add('is-zooming'); });
    galleryEl.addEventListener('mouseleave', function () { galleryEl.classList.remove('is-zooming'); });
    galleryEl.addEventListener('mousemove', function (e) {
      lastEvent = e;
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(function () { applyMove(lastEvent); rafPending = false; });
    });
  }

  document.querySelectorAll('[data-magnifier]').forEach(initMagnifier);
}());
